import { ChatEngine } from 'react-chat-engine'
import ChatFeed from './components/ChatFeed';
import LoginForm from './components/LoginForm'
import './App.css'



const App = () => {
  if(!localStorage.getItem('username')) return <LoginForm/>

  return (
    <ChatEngine
      height="100vh"
      projectID="01aa1a9b-5c10-4381-bd67-58af4bc22be5"
      userName={localStorage.getItem('username')}
      usersecret={localStorage.getItem('password')}
      userSecret="pistondj"
      renderChatFeed={(chatAppProps)=><ChatFeed {...chatAppProps}/>}
    />
  )
}

export default App